var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainWidgetStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 7.58172 3.58172 4 8 4H58C62.4183 4 66 7.58172 66 12V62C66 66.4183 62.4183 70 58 70H8C3.58172 70 0 66.4183 0 62V12Z",
    fill: "#EEEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 7.85786 3.85786 4.5 8 4.5H58C62.1421 4.5 65.5 7.85786 65.5 12V62C65.5 66.1421 62.1421 69.5 58 69.5H8C3.85786 69.5 0.5 66.1421 0.5 62V12Z",
    stroke: "black",
    strokeOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11C5 9.89543 5.89543 9 7 9H27C28.1046 9 29 9.89543 29 11V17C29 18.1046 28.1046 19 27 19H7C5.89543 19 5 18.1046 5 17V11Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 56,
    height: 42,
    rx: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainWidgetStyle);
export default __webpack_public_path__ + "static/media/icon-main-widget-style.10c2dca9169f9662db58825120f457bd.svg";
export { ForwardRef as ReactComponent };